/**
 * Placeholder — temporary page for nav routes not yet migrated to React. Keeps
 * the whole sidebar navigable during the B1–B5 migration; each one is replaced
 * by its real page as the batches land. Derives its title from the nav config.
 */
import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { SIDEBAR_SECTIONS } from '../nav/config';
import { Page } from '../components/Page';

export function Placeholder() {
  const location = useLocation();
  const id = location.pathname.replace(/^\/+/, '').split('/')[0] || 'dashboard';
  const item = SIDEBAR_SECTIONS.flatMap((s) => s.items).find((it) => it.id === id);
  const label = item?.label ?? id;

  return (
    <Page title={label}>
      <div className="card p-8 flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-brand-50 flex items-center justify-center mb-3">
          <Construction className="w-6 h-6 text-brand-600" />
        </div>
        <p className="text-sm font-medium text-gray-900">หน้านี้กำลังย้ายมาเป็น React</p>
        <p className="text-sm text-gray-500 mt-1 max-w-sm">
          โครงสร้างใหม่พร้อมแล้ว — เนื้อหาหน้า “{label}” จะถูกย้ายมาในรอบ migration (B1–B5)
        </p>
        <code className="mt-3 text-xs text-gray-400">route: /{id}</code>
      </div>
    </Page>
  );
}
